export enum LookingForOptionId {
    Curious = 'curious',
    Serious = 'serious',
    BankQuote = 'bankQuote',
}

export default LookingForOptionId;
